export default "__VITE_ASSET__CNPCxXyk__"